import React from 'react';
import { useTranslation } from 'react-i18next';
import { CoreLink } from '@uncinc/react-drupal-core';

import useLayoutVariables from '../../../hooks/useLayoutVariables';

import './style.scss';

interface LogoProps {
  toggleOverlay?: (arg0?: boolean) => void;
}

const Logo: React.FC<LogoProps> = ({ toggleOverlay }) => {
  const { LogoSVG } = useLayoutVariables('logo');
  const { t } = useTranslation();

  return (
    <CoreLink
      className="Logo"
      href="/"
      aria-label={t('aria-labels.menu_aria_label')}
      onClick={() => toggleOverlay && toggleOverlay(true)}
    >
      <LogoSVG />
    </CoreLink>
  );
};

export default Logo;
